import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userSearchRequest } from '../../redux/actions/users';
import Icon from '../Icon';

const ComboBoxUser = ({
  id,
  inputPlaceholder,
  selectedUser,
  userSelect,
  organizationId,
}) => {
  const dispatch = useDispatch();
  const [showList, setShowList] = useState(false);
  const [value, setValue] = useState('');
  const [change, setChange] = useState(false);
  const list = useSelector((state) => state.users.list);

  useEffect(() => {
    if (selectedUser) {
      setValue(selectedUser.userName);
    }
  }, [selectedUser]);

  useEffect(() => {
    // annoy selection trigger
    if (change) {
      dispatch(
        userSearchRequest(value, organizationId ? organizationId : null)
      );
    }
  }, [dispatch, value, change, organizationId]);

  const elementSelect = (user) => {
    setShowList(!showList);
    dispatch(userSelect(user));
    setChange(false);
    setValue(user.userName);
  };

  const inputChange = (e) => {
    if (e.target.value === '') {
      dispatch(userSelect({}));
    }
    setValue(e.target.value);
    setChange(true);
    setShowList(true);
  };

  const suffixIcon = () => {
    if (!value) return 'search';
    else return 'x';
  };

  const removeInput = () => {
    if (value) {
      setValue('');
      dispatch(userSelect({}));
      setChange(true);
    }
  };

  const itemsList = list.map((item) => (
    <div
      key={item.userId}
      className='km__c--combobox-element'
      onClick={() => {
        elementSelect(item);
      }}
    >
      <div className='km__c--combobox-element-name'>{item.userName}</div>
      <div className='km__c--combobox-element-id'>ID: {item.userId}</div>
    </div>
  ));

  return (
    <div className='km__c--combobox-container'>
      <div className='km__c--input-container'>
        <input
          className='km__c--input km__c--input-has-icon'
          placeholder={inputPlaceholder}
          onClick={() => setShowList(!showList)}
          onChange={inputChange}
          value={value || ''}
          id={id}
          autoComplete='off'
        />
        <Icon
          name={suffixIcon()}
          className='km__c--combobox-remove-button'
          onClick={removeInput}
          size='16'
        />
      </div>
      {list.length > 0 && showList && (
        <div className='km__c--combobox-list'>{itemsList}</div>
      )}
    </div>
  );
};

export default ComboBoxUser;
